import { utf8ToSjis } from './encoding'

export function downloadBlob(blob, filename) {
    let a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename;

    document.body.appendChild(a);
    a.click();

    URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
}

export function downloadSvg(svg, filename) {
    let svgData = new XMLSerializer().serializeToString(svg);
    let canvas = document.createElement("canvas");
    canvas.width = svg.width.baseVal.value;
    canvas.height = svg.height.baseVal.value;

    let ctx = canvas.getContext("2d");
    let image = new Image;
    image.src = 'data:image/svg+xml;charset=utf-8;base64,' + btoa(svgData);
    image.onload = function(){
        ctx.drawImage( image, 0, 0 );
        let a = document.createElement("a");
        a.href = canvas.toDataURL("image/png");
        a.download = filename;
        a.click();
    }
}

export function downloadCsv(header, records, filename) {
    let csv = "";

    csv += header.join(",") + "\n";
    for (let record of records) {
        csv += record.join(",") + "\n";
    }

    csv = utf8ToSjis(csv);

    let blob = new Blob([csv], {type:'text/csv'});
    downloadBlob(blob, filename);
}
